import { css, createGlobalStyle } from 'styled-components';
import { darkMode, darkPalette } from './darkTheme';

export const GlobalStyles = createGlobalStyle<{ $showCookieBanner: boolean }>(
  ({ $showCookieBanner }) => css`
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
      font-family: Avenir, sans-serif;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      -webkit-tap-highlight-color: transparent;
      -webkit-text-size-adjust: none;
      direction: ${({ theme }) => (theme.isRtl ? 'rtl' : 'ltr')};

      &::-webkit-scrollbar {
        width: 0;
      }
    }

    html {
      overflow-x: hidden;
    }

    body {
      min-height: 100dvh;
      min-width: 350px;
      overflow-x: hidden;
    }

    body > * {
      height: auto;
    }

    /* Hidden helper iframes, such as the Braintree dispatch frame, declare height=0, but the ui-components
       body > * { height: 100% } rule stretched them. On RTL pages that height showed up below the footer */
    body > iframe[height='0'] {
      height: 0;
      border: 0;
    }

    //Gooogle Map Global Styles

    .gm-style .gm-style-iw-c {
      padding: 0;
      background-color: transparent;
      box-shadow: none;
      border-radius: 22px;
      transform: translate(-50%, -165%);
      max-width: unset !important;
      max-height: unset !important;
      top: 90px;

      &:focus {
        outline: none !important;
      }
    }

    .gm-style .gm-style-iw-tc {
      display: none;
    }

    .gm-style-iw-d {
      overflow: hidden !important;
      max-width: unset !important;
      max-height: unset !important;
    }

    .gm-ui-hover-effect {
      display: none !important;
    }

    .gm-style-iw-t::after {
      width: 0 !important;
    }

    .gmnoprint.gm-bundled-control.gm-bundled-control-on-bottom,
    .gmnoprint.gm-bundled-control {
      div {
        background-color: transparent !important;
        border: none !important;
        box-shadow: none !important;
      }

      .gm-control-active {
        background-color: #fff !important;
        border-radius: 50% !important;
        margin-bottom: 15px !important;
      }
    }

    .gmnoprint {
      z-index: 2000 !important;
    }

    //Overriding phone input styles

    .PhoneInput {
      width: 100%;
      direction: ltr;

      & > * {
        direction: ltr;
      }
    }

    .PhoneInputInput:focus {
      &:focus,
      &:visited,
      &:active {
        outline: none;
        border: 1px solid #1f7ace;
        border-radius: 12px;
        -webkit-border-radius: 12px;
        -moz-border-radius: 12px;
        -ms-border-radius: 12px;
      }
    }

    .PhoneInputInput {
      width: 100%;
      height: 51px;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      letter-spacing: -0.41px;
      color: #323232;
      border: none;
      border-bottom: 1px solid rgba(212, 218, 224, 1);
      border-top: 1px solid rgba(212, 218, 224, 1);
      border-left: 1px solid rgba(212, 218, 224, 1);
      border-right: 1px solid rgba(212, 218, 224, 1);
      padding: 14px 16px;
      padding-left: 80px;
      border-radius: 12px;
      background: #f6f6f6;

      &:focus,
      &:visited,
      &:active {
        outline: none;
        border: 1px solid #1f7ace;
        border-radius: 12px;
        -webkit-border-radius: 12px;
        -moz-border-radius: 12px;
        -ms-border-radius: 12px;
      }

      &::placeholder {
        color: #848484;
        font-weight: 400;
      }
    }

    .PhoneInputCountry {
      display: flex;
      position: absolute;
      left: 20px;
      top: 50%;
      transform: translateY(-50%);
    }

    .PhoneInputCountrySelect {
      opacity: 0;
      position: absolute;
      left: 32px;
      z-index: 100;
      width: 15px;
      outline: none;
      border: none;
      background: transparent;
    }

    .PhoneInputCountryIcon {
      width: 28px;
      height: 20px;
    }

    .PhoneInputCountryIcon--border {
      background-color: transparent;
      border: none;
      box-shadow: none;
    }

    .cky-consent-container {
      display: ${$showCookieBanner ? 'flex' : 'none'};
    }

    /* CookieYes keeps its close button on the right over an RTL title, and its styles load after ours */
    html[dir='rtl'] .cky-consent-container .cky-banner-btn-close {
      right: auto !important;
      left: 16px !important;
    }

    ${darkMode(css`
      /* :root raises specificity over the html/body rules of the ui-components global styles */
      :root,
      :root body {
        background-color: ${darkPalette.background};
        color: ${darkPalette.textPrimary};
      }

      .PhoneInputInput {
        color: ${darkPalette.textPrimary};
        background: ${darkPalette.surface};
        border-color: ${darkPalette.surface};

        &:focus,
        &:visited,
        &:active {
          border-color: ${darkPalette.accent};
        }

        &::placeholder {
          color: ${darkPalette.textTertiary};
        }
      }

      .gmnoprint.gm-bundled-control .gm-control-active {
        background-color: ${darkPalette.surface} !important;
      }
    `)}
  `,
);
